import React, { FC } from 'react';
import { PowerBiReportsList } from './components/PowerBiReportsList';
import { PowerBiReport } from './components/PowerBiReport';
import { GlobalStyle } from './AppStyle';
import styled, { ThemeProvider } from 'styled-components/macro';
import { theme } from './theme';
import { Hamburger } from './components/Hamburger';
import { HeaderBar } from './components/HeaderBar';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from './redux/RootState';
import { AppActions } from './redux/actions/app';
import { FooterBar } from './components/FooterBar';

const App: FC = () => {
    const showMainMenu = useSelector((s: RootState) => s.app.showMainMenu);
    const isLoggedOn = useSelector((s: RootState) => s.user.isLoggedOn);
    const reports = useSelector((s: RootState) => s.powerBi.reports);
    const dispatch = useDispatch();
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle />
            <AppGrid className="App">
                <HeaderBar className="header" />
                <aside className={['main-menu', ...(!showMainMenu ? ['menu-hidden'] : [])].join(' ')}>
                    {isLoggedOn && reports.length > 0 && (
                        <Ham>
                            <Hamburger
                                onClick={() => dispatch(AppActions.showMainMenu(!showMainMenu))}
                                open={showMainMenu}
                                transitionTime="1s"
                            />
                        </Ham>
                    )}
                    <div className="menu-content">
                        <PowerBiReportsList />
                    </div>
                </aside>
                <div className="content">
                    <PowerBiReport />
                </div>
                <div className="context-menu menu-hidden">
                    <div className="menu-content"></div>
                </div>
                <FooterBar className="footer" />
            </AppGrid>
        </ThemeProvider>
    );
};

const Ham = styled.div`
    text-align: right;
    padding: 0.5em;
    padding-bottom: 0;
    box-sizing: border-box;
`;

const AppGrid = styled.div`
    min-height: 100vh;
    width: 100%;
    display: grid;
    grid-template-columns: min-content 1fr min-content;
    grid-template-rows: ${(props) => props.theme.headerBar.height} 1fr ${(props) => props.theme.footerBar.height};
    gap: 0px 0px;
    grid-template-areas: 'header header header' 'main-menu content context-menu' 'footer footer footer';
    .main-menu {
        grid-area: main-menu;
        /* border-right: solid 1px #ccc; */
        overflow: hidden;
        transition: background-color 1s;
        background-color: ${(props) => props.theme.colors.primary.backgroundColor};
        /* &.menu-hidden {
            border-right: solid 1px transparent;
        } */
    }

    .menu-content {
        position: relative;
        transition: width 1s, opacity 0.5s 0.15s;
        width: ${(props) => props.theme.mainMenu.width};
    }

    .context-menu {
        grid-area: context-menu;
        /* border-left: solid 1px #ccc; */
        overflow: hidden;
    }

    .menu-hidden {
        border: none;
        background-color: ${(props) => props.theme.colors.secondary.backgroundColor};
        .menu-content {
            width: 0;
            opacity: 0;
        }
    }

    .content {
        grid-area: content;
        position: relative;
        background-color: ${(props) => props.theme.colors.secondary.backgroundColor};
        /* padding: 1em; */
    }

    .header {
        grid-area: header;
        border-bottom: solid ${(props) => props.theme.borders.thickness} ${(props) => props.theme.borders.color};
    }

    .footer {
        grid-area: footer;
        border-top: solid ${(props) => props.theme.borders.thickness} ${(props) => props.theme.borders.color};
    }
`;

export default App;
